import React from 'react';

const Termos: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero */}
      <div className="bg-gradient-to-br from-green-700 to-green-900 text-white py-16">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Termos de Uso</h1>
          <p className="text-green-100">Última atualização: Fevereiro de 2026</p>
        </div>
      </div>

      <div className="container-custom py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm p-8 md:p-12">
          <div className="prose prose-green max-w-none">
            <h2>1. Aceitação dos Termos</h2>
            <p>
              Ao acessar e usar a plataforma BOILX, você concorda com estes Termos de Uso. Se você não concordar com qualquer parte destes termos, não utilize nossos serviços.
            </p>

            <h2>2. Descrição do Serviço</h2>
            <p>
              A BOILX é uma plataforma online que conecta compradores e vendedores de animais, especialmente equinos e bovinos. Atuamos como intermediários, facilitando a comunicação entre as partes.
            </p>

            <h2>3. Cadastro e Conta</h2>
            <p>Para utilizar nossos serviços, você deve:</p>
            <ul>
              <li>Ter pelo menos 18 anos de idade</li>
              <li>Fornecer informações verdadeiras e atualizadas</li>
              <li>Manter a confidencialidade de sua senha</li>
              <li>Ser responsável por todas as atividades em sua conta</li>
            </ul>

            <h2>4. Regras de Uso</h2>
            <p>Ao usar a BOILX, você concorda em:</p>
            <ul>
              <li>Não publicar conteúdo falso, enganoso ou fraudulento</li>
              <li>Não infringir direitos de terceiros</li>
              <li>Não utilizar a plataforma para fins ilegais</li>
              <li>Não criar múltiplas contas</li>
              <li>Não manipular preços ou avaliações</li>
            </ul>

            <h2>5. Anúncios</h2>
            <p>
              Os anúncios publicados são de responsabilidade exclusiva do anunciante. A BOILX se reserva o direito de remover anúncios que violem nossas políticas.
            </p>

            <h2>6. Pagamentos</h2>
            <p>
              Os pagamentos por planos e serviços premium são processados por parceiros terceiros (Stripe e PagSeguro). A BOILX não armazena dados de cartão de crédito.
            </p>

            <h2>7. Limitação de Responsabilidade</h2>
            <p>
              A BOILX não se responsabiliza por transações realizadas entre usuários, incluindo qualidade dos animais, entrega ou pagamentos feitos fora da plataforma.
            </p>

            <h2>8. Propriedade Intelectual</h2>
            <p>
              Todo o conteúdo da plataforma (marca, design, código) é propriedade da BOILX. O conteúdo gerado por usuários permanece de propriedade dos mesmos.
            </p>

            <h2>9. Modificações</h2>
            <p>
              Reservamo-nos o direito de modificar estes termos a qualquer momento. Alterações significativas serão comunicadas por e-mail ou notificação na plataforma.
            </p>

            <h2>10. Encerramento</h2>
            <p>
              Podemos suspender ou encerrar sua conta por violação destes termos, sem aviso prévio e sem direito a reembolso de valores pagos.
            </p>

            <h2>11. Legislação Aplicável</h2>
            <p>
              Estes termos são regidos pelas leis da República Federativa do Brasil. Qualquer disputa será resolvida no foro da comarca de Campos dos Goytacazes, RJ.
            </p>

            <h2>12. Contato</h2>
            <p>
              Para dúvidas sobre estes termos, entre em contato: <a href="mailto:legal@boilx.com.br">legal@boilx.com.br</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Termos;
